import React, { memo } from "react";

function HoverAbleElement( props: { char: string } ) {
    return <span className={ "transition-all duration-300 inline-block ease-out h-[30px] hsover:translate-y-[-20px] m-auto  ml-1 hover:scale-150" }>
        { props.char }
    </span>
}

function HoverAbleWord( props: { word: string } ) {
    let chars = props.word.split( '' )
    return (
        <>
            { chars.map( ( char, index ) => <HoverAbleElement
                key={ index }
                char={ char }
            /> ) }
        </>
    )
}

export default memo( HoverAbleWord )